<div *ngIf="user && group" class="p-10 container mx-auto">
  <form [formGroup]="group" (ngSubmit)="save()">
    <span *ngIf="group.touched">touched</span>
    <dx-text-area valueChangeEvent="keyup" formControlName="userName"></dx-text-area>
    <div *ngIf="group.touched">
      <div *ngIf="group.get('userName')!.hasError('minlength')"
            class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded"
      >min length 3</div>


      <div *ngIf="group.get('userName')!.hasError('required')"
      class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded"
      >required</div>
    </div>



    <dx-text-area valueChangeEvent="keyup" formControlName="email"></dx-text-area>

    <dx-button *ngIf="group.valid"
                class="pt-5"
                [useSubmitBehavior]="true"
    >save</dx-button>
    <dx-button *ngIf="group.touched" (click)="group.reset()">reset</dx-button>
  </form>
</div>